import { config } from "../utilities/configs";
import { http } from "../utilities/http";

let ContactUsService = {
  add: async (request) => {
    const resp = await http.post(config.baseUrl + "/contact-us", request);
    return resp;
  },
};

export { ContactUsService };
